@if (isStudent === true) {
<div class="flex flex-col items-center">
    <div class="max-w-[1100px] my-[20px]">
        <div class="flex flex-wrap gap-[12px] text-xs">
            <span class="inactive">Instructions</span>
            <span class="inactive">Student Info</span>
            <span class="inactive">Financial Info</span>
            <span class="inactive">Family Info</span>
            <span class="inactive">College/Experience</span>
            <span class="inactive">Essay</span>
            <span class="inactive">Scholarship Selection</span>
            <span class="inactive">Signature</span>
            <span class="active">Submitted Application</span>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div class="flex flex-wrap justify-center gap-[10px]">
        <button mat-raised-button (click)="pdf()">Download PDF of Application</button>
        <button mat-raised-button (click)="viewSelected()">View Selected Scholarship Details</button>
    </div>
</div>
}
<app-application-summary [details]="details"></app-application-summary>